<div class="w-100 h-100 d-flex flex-column align-items-center justify-content-between gap-3">

  <ng-container *ngIf="!isVerified; else verified">
    <div class="spinner-border spinner-border-lg color-primary" role="status"></div>
    <h3 class="mb-0">{{ 'verification.title' | translate }}</h3>
    <p class="lead mb-0">{{ 'verification.message' | translate: { number: getMaskedNumber(number)}  }}</p>
  </ng-container>

  <ng-template #verified>
    <span class="material-symbols-outlined text-success" style="font-size: 64px;">
      check_circle
    </span>
    <ng-container *ngIf="audience === 'clinic'; else patientVerified">
      <h3 class="mb-0">{{ 'verification.clinic-title-verified' | translate }}</h3>
      <p class="lead mb-0">{{ 'verification.clinic-message-verified' | translate }}</p>
    </ng-container>
    <ng-template #patientVerified>
      <h3 class="mb-0">{{ 'verification.title-verified' | translate }}</h3>
      <p class="lead mb-0">{{ 'verification.message-verified' | translate: { number: getMaskedNumber(number)}  }}</p>
    </ng-template>
  </ng-template>
</div>